/* eslint-disable react/display-name */
import { createElement } from 'rlink-react';
import Redirect from 'rlink-router/Redirect';

export default function (params, _content) {
  return <Redirect view="home" params={params} />;
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/views/legacy-redirect.jsx